const customLangs = {
    gb: {
        _name: 'English',
        newDesign: {
            other: {
                trustisag: "Einkommensnachweis"
            },
            otherDocuments: {
                trustisag: "Letzte Lohnabrechnung oder letzter Rentenbescheid.<br>Falls Sie eine Rente beziehen und zusätzlich arbeiten, laden Sie bitte beide Dokumente hoch.<br>Diese Angaben werden zur Deklaration Ihrer Einkünfte aus dem Handel an der Börse benötigt."
            },
            savingsAccounts: {
                canadatokentrade: 'Savings/IPO/ICO',
                avxsolutions: 'Savings/IPO/ICO',
            },
        },
        fullScreen: {
            savings: {
                canadatokentrade: 'Savings/IPO/ICO',
                avxsolutions: 'Savings/IPO/ICO',
            }
        },
    },
    ru: {
        _name: 'Русский',
        newDesign: {
            other: {
                trustisag: "Einkommensnachweis"
            },
            otherDocuments: {
                trustisag: "Letzte Lohnabrechnung oder letzter Rentenbescheid.<br>Falls Sie eine Rente beziehen und zusätzlich arbeiten, laden Sie bitte beide Dokumente hoch.<br>Diese Angaben werden zur Deklaration Ihrer Einkünfte aus dem Handel an der Börse benötigt."
            },
            savingsAccounts: {
                canadatokentrade: 'Savings/IPO/ICO',
                avxsolutions: 'Savings/IPO/ICO',
            },
        },
        fullScreen: {
            savings: {
                canadatokentrade: 'Savings/IPO/ICO',
                avxsolutions: 'Savings/IPO/ICO',
            }
        },
    },
    pl: {
        _name: 'Polski',
        newDesign: {
            other: {
                trustisag: "Einkommensnachweis"
            },
            otherDocuments: {
                trustisag: "Letzte Lohnabrechnung oder letzter Rentenbescheid.<br>Falls Sie eine Rente beziehen und zusätzlich arbeiten, laden Sie bitte beide Dokumente hoch.<br>Diese Angaben werden zur Deklaration Ihrer Einkünfte aus dem Handel an der Börse benötigt."
            },
            savingsAccounts: {
                canadatokentrade: 'Savings/IPO/ICO',
                avxsolutions: 'Savings/IPO/ICO',
            },
        },
        fullScreen: {
            savings: {
                canadatokentrade: 'Savings/IPO/ICO',
                avxsolutions: 'Savings/IPO/ICO',
            }
        },
    },
    cz: {
        _name: 'Čeština',
        newDesign: {
            other: {
                trustisag: "Einkommensnachweis"
            },
            otherDocuments: {
                trustisag: "Letzte Lohnabrechnung oder letzter Rentenbescheid.<br>Falls Sie eine Rente beziehen und zusätzlich arbeiten, laden Sie bitte beide Dokumente hoch.<br>Diese Angaben werden zur Deklaration Ihrer Einkünfte aus dem Handel an der Börse benötigt."
            },
            savingsAccounts: {
                canadatokentrade: 'Savings/IPO/ICO',
                avxsolutions: 'Savings/IPO/ICO',
            },
        },
        fullScreen: {
            savings: {
                canadatokentrade: 'Savings/IPO/ICO',
                avxsolutions: 'Savings/IPO/ICO',
            }
        },
    },
    de: {
        _name: 'Deutsch',
        newDesign: {
            other: {
                trustisag: "Einkommensnachweis"
            },
            otherDocuments: {
                trustisag: "Letzte Lohnabrechnung oder letzter Rentenbescheid.<br>Falls Sie eine Rente beziehen und zusätzlich arbeiten, laden Sie bitte beide Dokumente hoch.<br>Diese Angaben werden zur Deklaration Ihrer Einkünfte aus dem Handel an der Börse benötigt."
            },
            savingsAccounts: {
                canadatokentrade: 'Savings/IPO/ICO',
                avxsolutions: 'Savings/IPO/ICO',
            },
        },
        fullScreen: {
            savings: {
                canadatokentrade: 'Savings/IPO/ICO',
                avxsolutions: 'Savings/IPO/ICO',
            }
        },
    },
    fr: {
        _name: 'Français',
        newDesign: {
            other: {
                trustisag: "Einkommensnachweis"
            },
            otherDocuments: {
                trustisag: "Letzte Lohnabrechnung oder letzter Rentenbescheid.<br>Falls Sie eine Rente beziehen und zusätzlich arbeiten, laden Sie bitte beide Dokumente hoch.<br>Diese Angaben werden zur Deklaration Ihrer Einkünfte aus dem Handel an der Börse benötigt."
            },
            savingsAccounts: {
                canadatokentrade: 'Savings/IPO/ICO',
                avxsolutions: 'Savings/IPO/ICO',
            },
        },
        fullScreen: {
            savings: {
                canadatokentrade: 'Savings/IPO/ICO',
                avxsolutions: 'Savings/IPO/ICO',
            }
        }
    },
    es: {
        _name: 'Español',
        newDesign: {
            other: {
                trustisag: "Einkommensnachweis"
            },
            otherDocuments: {
                trustisag: "Letzte Lohnabrechnung oder letzter Rentenbescheid.<br>Falls Sie eine Rente beziehen und zusätzlich arbeiten, laden Sie bitte beide Dokumente hoch.<br>Diese Angaben werden zur Deklaration Ihrer Einkünfte aus dem Handel an der Börse benötigt."
            },
            savingsAccounts: {
                canadatokentrade: 'Savings/IPO/ICO',
                avxsolutions: 'Savings/IPO/ICO',
            },
        },
        fullScreen: {
            savings: {
                canadatokentrade: 'Savings/IPO/ICO',
                avxsolutions: 'Savings/IPO/ICO',
            }
        },
    },
    dk: {
        _name: 'Dansk',
        newDesign: {
            other: {
                trustisag: "Einkommensnachweis"
            },
            otherDocuments: {
                trustisag: "Letzte Lohnabrechnung oder letzter Rentenbescheid.<br>Falls Sie eine Rente beziehen und zusätzlich arbeiten, laden Sie bitte beide Dokumente hoch.<br>Diese Angaben werden zur Deklaration Ihrer Einkünfte aus dem Handel an der Börse benötigt."
            },
            savingsAccounts: {
                canadatokentrade: 'Savings/IPO/ICO',
                avxsolutions: 'Savings/IPO/ICO',
            },
        },
        fullScreen: {
            savings: {
                canadatokentrade: 'Savings/IPO/ICO',
                avxsolutions: 'Savings/IPO/ICO',
            }
        },
    },
    nl: {
        _name: 'Nederlandse taal',
        newDesign: {
            other: {
                trustisag: "Einkommensnachweis"
            },
            otherDocuments: {
                trustisag: "Letzte Lohnabrechnung oder letzter Rentenbescheid.<br>Falls Sie eine Rente beziehen und zusätzlich arbeiten, laden Sie bitte beide Dokumente hoch.<br>Diese Angaben werden zur Deklaration Ihrer Einkünfte aus dem Handel an der Börse benötigt."
            },
            savingsAccounts: {
                canadatokentrade: 'Savings/IPO/ICO',
                avxsolutions: 'Savings/IPO/ICO',
            },
        },
        fullScreen: {
            savings: {
                canadatokentrade: 'Savings/IPO/ICO',
                avxsolutions: 'Savings/IPO/ICO',
            }
        },
    },
    sa: {
        _name: 'عربي',
        newDesign: {
            other: {
                trustisag: "Einkommensnachweis"
            },
            otherDocuments: {
                trustisag: "Letzte Lohnabrechnung oder letzter Rentenbescheid.<br>Falls Sie eine Rente beziehen und zusätzlich arbeiten, laden Sie bitte beide Dokumente hoch.<br>Diese Angaben werden zur Deklaration Ihrer Einkünfte aus dem Handel an der Börse benötigt."
            },
            savingsAccounts: {
                canadatokentrade: 'Savings/IPO/ICO',
                avxsolutions: 'Savings/IPO/ICO',
            },
        },
        fullScreen: {
            savings: {
                canadatokentrade: 'Savings/IPO/ICO',
                avxsolutions: 'Savings/IPO/ICO',
            }
        },
    },
    it: {
        _name: 'Italiano',
        newDesign: {
            other: {
                trustisag: "Einkommensnachweis"
            },
            otherDocuments: {
                trustisag: "Letzte Lohnabrechnung oder letzter Rentenbescheid.<br>Falls Sie eine Rente beziehen und zusätzlich arbeiten, laden Sie bitte beide Dokumente hoch.<br>Diese Angaben werden zur Deklaration Ihrer Einkünfte aus dem Handel an der Börse benötigt."
            },
            savingsAccounts: {
                canadatokentrade: 'Savings/IPO/ICO',
                avxsolutions: 'Savings/IPO/ICO',
            },
        },
        fullScreen: {
            savings: {
                canadatokentrade: 'Savings/IPO/ICO',
                avxsolutions: 'Savings/IPO/ICO',
            }
        },
    },
    sk: {
        _name: 'Slovak',
        newDesign: {
            other: {
                trustisag: "Einkommensnachweis"
            },
            otherDocuments: {
                trustisag: "Letzte Lohnabrechnung oder letzter Rentenbescheid.<br>Falls Sie eine Rente beziehen und zusätzlich arbeiten, laden Sie bitte beide Dokumente hoch.<br>Diese Angaben werden zur Deklaration Ihrer Einkünfte aus dem Handel an der Börse benötigt."
            },
            savingsAccounts: {
                canadatokentrade: 'Savings/IPO/ICO',
                avxsolutions: 'Savings/IPO/ICO',
            },
        },
        fullScreen: {
            savings: {
                canadatokentrade: 'Savings/IPO/ICO',
                avxsolutions: 'Savings/IPO/ICO',
            }
        },
    },
    hu: {
        _name: 'Hungarian',
        newDesign: {
            other: {
                trustisag: "Einkommensnachweis"
            },
            otherDocuments: {
                trustisag: "Letzte Lohnabrechnung oder letzter Rentenbescheid.<br>Falls Sie eine Rente beziehen und zusätzlich arbeiten, laden Sie bitte beide Dokumente hoch.<br>Diese Angaben werden zur Deklaration Ihrer Einkünfte aus dem Handel an der Börse benötigt."
            },
            savingsAccounts: {
                canadatokentrade: 'Savings/IPO/ICO',
                avxsolutions: 'Savings/IPO/ICO',
            },
        },
        fullScreen: {
            savings: {
                canadatokentrade: 'Savings/IPO/ICO',
                avxsolutions: 'Savings/IPO/ICO',
            }
        },
    },
    ro: {
        _name: 'Romanian',
        newDesign: {
            other: {
                trustisag: "Einkommensnachweis"
            },
            otherDocuments: {
                trustisag: "Letzte Lohnabrechnung oder letzter Rentenbescheid.<br>Falls Sie eine Rente beziehen und zusätzlich arbeiten, laden Sie bitte beide Dokumente hoch.<br>Diese Angaben werden zur Deklaration Ihrer Einkünfte aus dem Handel an der Börse benötigt."
            },
            savingsAccounts: {
                canadatokentrade: 'Savings/IPO/ICO',
                avxsolutions: 'Savings/IPO/ICO',
            },
        },
        fullScreen: {
            savings: {
                canadatokentrade: 'Savings/IPO/ICO',
                avxsolutions: 'Savings/IPO/ICO',
            }
        },
    },
    ge: {
        _name: 'Georgia',
        newDesign: {
            other: {
                trustisag: "Einkommensnachweis"
            },
            otherDocuments: {
                trustisag: "Letzte Lohnabrechnung oder letzter Rentenbescheid.<br>Falls Sie eine Rente beziehen und zusätzlich arbeiten, laden Sie bitte beide Dokumente hoch.<br>Diese Angaben werden zur Deklaration Ihrer Einkünfte aus dem Handel an der Börse benötigt."
            },
            savingsAccounts: {
                canadatokentrade: 'Savings/IPO/ICO',
                avxsolutions: 'Savings/IPO/ICO',
            },
        },
        fullScreen: {
            savings: {
                canadatokentrade: 'Savings/IPO/ICO',
                avxsolutions: 'Savings/IPO/ICO',
            }
        },
    },
    az: {
        _name: 'Azerbaijani',
        newDesign: {
            other: {
                trustisag: "Einkommensnachweis"
            },
            otherDocuments: {
                trustisag: "Letzte Lohnabrechnung oder letzter Rentenbescheid.<br>Falls Sie eine Rente beziehen und zusätzlich arbeiten, laden Sie bitte beide Dokumente hoch.<br>Diese Angaben werden zur Deklaration Ihrer Einkünfte aus dem Handel an der Börse benötigt."
            },
            savingsAccounts: {
                canadatokentrade: 'Savings/IPO/ICO',
                avxsolutions: 'Savings/IPO/ICO',
            },
        },
        fullScreen: {
            savings: {
                canadatokentrade: 'Savings/IPO/ICO',
                avxsolutions: 'Savings/IPO/ICO',
            }
        },
    },
    tr: {
        _name: 'Türkçe',
        newDesign: {
            other: {
                trustisag: "Einkommensnachweis"
            },
            otherDocuments: {
                trustisag: "Letzte Lohnabrechnung oder letzter Rentenbescheid.<br>Falls Sie eine Rente beziehen und zusätzlich arbeiten, laden Sie bitte beide Dokumente hoch.<br>Diese Angaben werden zur Deklaration Ihrer Einkünfte aus dem Handel an der Börse benötigt."
            },
            savingsAccounts: {
                canadatokentrade: 'Savings/IPO/ICO',
                avxsolutions: 'Savings/IPO/ICO',
            },
        },
        fullScreen: {
            savings: {
                canadatokentrade: 'Savings/IPO/ICO',
                avxsolutions: 'Savings/IPO/ICO',
            }
        },
    },
    rs: {
        _name: 'Srpski',
        newDesign: {
            other: {
                trustisag: "Einkommensnachweis"
            },
            otherDocuments: {
                trustisag: "Letzte Lohnabrechnung oder letzter Rentenbescheid.<br>Falls Sie eine Rente beziehen und zusätzlich arbeiten, laden Sie bitte beide Dokumente hoch.<br>Diese Angaben werden zur Deklaration Ihrer Einkünfte aus dem Handel an der Börse benötigt."
            },
            savingsAccounts: {
                canadatokentrade: 'Savings/IPO/ICO',
                avxsolutions: 'Savings/IPO/ICO',
            },
        },
        fullScreen: {
            savings: {
                canadatokentrade: 'Savings/IPO/ICO',
                avxsolutions: 'Savings/IPO/ICO',
            }
        },
    },
    pt: {
        _name: 'Português',
        newDesign: {
            other: {
                trustisag: "Einkommensnachweis"
            },
            otherDocuments: {
                trustisag: "Letzte Lohnabrechnung oder letzter Rentenbescheid.<br>Falls Sie eine Rente beziehen und zusätzlich arbeiten, laden Sie bitte beide Dokumente hoch.<br>Diese Angaben werden zur Deklaration Ihrer Einkünfte aus dem Handel an der Börse benötigt."
            },
            savingsAccounts: {
                canadatokentrade: 'Savings/IPO/ICO',
                avxsolutions: 'Savings/IPO/ICO',
            },
        },
        fullScreen: {
            savings: {
                canadatokentrade: 'Savings/IPO/ICO',
                avxsolutions: 'Savings/IPO/ICO',
            }
        },
    },
    jp: {
        _name: '日本語',
        newDesign: {
            other: {
                trustisag: "Einkommensnachweis"
            },
            otherDocuments: {
                trustisag: "Letzte Lohnabrechnung oder letzter Rentenbescheid.<br>Falls Sie eine Rente beziehen und zusätzlich arbeiten, laden Sie bitte beide Dokumente hoch.<br>Diese Angaben werden zur Deklaration Ihrer Einkünfte aus dem Handel an der Börse benötigt."
            },
            savingsAccounts: {
                canadatokentrade: 'Savings/IPO/ICO',
                avxsolutions: 'Savings/IPO/ICO',
            },
        },
        fullScreen: {
            savings: {
                canadatokentrade: 'Savings/IPO/ICO',
                avxsolutions: 'Savings/IPO/ICO',
            }
        },
    },
    hr: {
        _name: 'Hrvatski',
        newDesign: {
            other: {
                trustisag: "Einkommensnachweis"
            },
            otherDocuments: {
                trustisag: "Letzte Lohnabrechnung oder letzter Rentenbescheid.<br>Falls Sie eine Rente beziehen und zusätzlich arbeiten, laden Sie bitte beide Dokumente hoch.<br>Diese Angaben werden zur Deklaration Ihrer Einkünfte aus dem Handel an der Börse benötigt."
            },
            savingsAccounts: {
                canadatokentrade: 'Savings/IPO/ICO',
                avxsolutions: 'Savings/IPO/ICO',
            },
        },
        fullScreen: {
            savings: {
                canadatokentrade: 'Savings/IPO/ICO',
                avxsolutions: 'Savings/IPO/ICO',
            }
        },
    },
    kz: {
        _name: 'Қазақ тілі',
        newDesign: {
            other: {
                trustisag: "Einkommensnachweis"
            },
            otherDocuments: {
                trustisag: "Letzte Lohnabrechnung oder letzter Rentenbescheid.<br>Falls Sie eine Rente beziehen und zusätzlich arbeiten, laden Sie bitte beide Dokumente hoch.<br>Diese Angaben werden zur Deklaration Ihrer Einkünfte aus dem Handel an der Börse benötigt."
            },
            savingsAccounts: {
                canadatokentrade: 'Savings/IPO/ICO',
                avxsolutions: 'Savings/IPO/ICO',
            },
        },
        fullScreen: {
            savings: {
                canadatokentrade: 'Savings/IPO/ICO',
                avxsolutions: 'Savings/IPO/ICO',
            }
        },
    },
    kg: {
        _name: 'Кыргыз тили',
        newDesign: {
            other: {
                trustisag: "Einkommensnachweis"
            },
            otherDocuments: {
                trustisag: "Letzte Lohnabrechnung oder letzter Rentenbescheid.<br>Falls Sie eine Rente beziehen und zusätzlich arbeiten, laden Sie bitte beide Dokumente hoch.<br>Diese Angaben werden zur Deklaration Ihrer Einkünfte aus dem Handel an der Börse benötigt."
            },
            savingsAccounts: {
                canadatokentrade: 'Savings/IPO/ICO',
                avxsolutions: 'Savings/IPO/ICO',
            },
        },
        fullScreen: {
            savings: {
                canadatokentrade: 'Savings/IPO/ICO',
                avxsolutions: 'Savings/IPO/ICO',
            }
        },
    },
    cn: {
        _name: '中文',
        newDesign: {
            other: {
                trustisag: "Einkommensnachweis"
            },
            otherDocuments: {
                trustisag: "Letzte Lohnabrechnung oder letzter Rentenbescheid.<br>Falls Sie eine Rente beziehen und zusätzlich arbeiten, laden Sie bitte beide Dokumente hoch.<br>Diese Angaben werden zur Deklaration Ihrer Einkünfte aus dem Handel an der Börse benötigt."
            },
            savingsAccounts: {
                canadatokentrade: 'Savings/IPO/ICO',
                avxsolutions: 'Savings/IPO/ICO',
            },
        },
        fullScreen: {
            savings: {
                canadatokentrade: 'Savings/IPO/ICO',
                avxsolutions: 'Savings/IPO/ICO',
            }
        },
    }
}

export default customLangs
